/**
 * Creates a new EquipmentCalibrationDetectorProbeController.
 * @class
 */
class EquipmentCalibrationDetectorProbeController {
    constructor($ngRedux, $state, $mdDialog, NavigationService, EquipmentCalibrationActions, Notifier) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$mdDialog = $mdDialog;
        this.NavigationService = NavigationService;
        this.actions = EquipmentCalibrationActions;
        this.Notifier = Notifier;
        this.grid = 'equipmentDetectorProbeGrid';
    }

    $onInit() {
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;
        this.icon = navConfig.icon;

        this.unsubscribe = this.$ngRedux.connect(this.mapState.bind(this), this.actions)(this);

        if (this.equipment.id) {
            this.identifier = 'app.equipmentCalibration.manage';
            this.state = 'app.equipmentCalibration.manage.detectorProbe';
        }
        else {
            this.identifier = 'app.equipmentCalibration.add';
            this.state = 'app.equipmentCalibration.add.detectorProbe';
        }

        this.getAssetTypes(this.equipment.type.id);
        this.getAssetCategories(this.equipment.type.id);
        this.getAssetRadiationTypes(this.equipment.type.id);
    }

    loadAssetModels = (event) => {
        if (this.detector.category && this.detector.manufacturer) {
            this.getModels('detector', this.detector.category, this.detector.manufacturer);
        }
    };

    createModel() {
        const createModelCtrl = ($scope) => {
            $scope.headerColor = this.colorName;
            $scope.addModel = () => {
                if ($scope.modelForm.$valid) {
                    this.addModel('detector', {
                        manufacturer: this.detector.manufacturer,
                        type: this.detector.category,
                        name: $scope.model.name,
                        description: ''
                    });
                    this.$mdDialog.hide();
                }
            };
            $scope.cancel = () => {
                this.$mdDialog.cancel();
            };
        };
        createModelCtrl.$inject = ['$scope'];

        this.$mdDialog.show({
            controller: createModelCtrl,
            template: require('../dialogs/equipment-model-dialog.html'),
            parent: angular.element(document.body),
            locals: {equipment: this.detector},
            clickOutsideToClose: true
        }).then(() => {}, angular.noop);
    }

    manageAsset() {
        if (this.assetForm.$valid) {
            if (this.detector.id) {
                this.editAsset(this.detector, this.grid).then(() => {
                    this.Notifier.success('Detector/Probe changes has been successfully saved');
                });
            }
            else {
                this.addAsset(this.detector, this.grid).then(() => {
                    this.assetForm.$setPristine();
                    this.assetForm.$setUntouched();
                    this.Notifier.success('New Detector/Probe has been successfully added');
                });
                this.$ngRedux.dispatch({
                    type: 'SET_DETECTOR',
                    id: 'detector',
                    data: {hasAssets: 1, detector: 1}
                });
            }
        }
        else this.Notifier.error('Please fill in the form fields');
    }

    onSelectAsset = (event) => {
        this.$ngRedux.dispatch({
            type: 'ASSET_DETAILS',
            id: 'detector',
            data: event.item
        });
    };

    onResetAsset = () => {
        this.$ngRedux.dispatch({
            type: 'ASSET_RESET',
            id: 'detector'
        });
        this.assetForm.$setPristine();
        this.assetForm.$setUntouched();
    };

    onRemoveAsset = (event) => {
        const confirm = this.$mdDialog.confirm()
            .title('Are you sure?')
            .textContent('Chosen asset will be removed permanently.')
            .ariaLabel('Remove asset')
            .ok('Yes')
            .cancel('No');

        this.removeDialog = this.$mdDialog.show(confirm).then(() => {
            this.removeAsset(event.item.equ_id, this.grid).then(() => {
                if (this.detectorsNumber == 1) {
                    this.$ngRedux.dispatch({
                        type: 'SET_DETECTOR',
                        id: 'detector',
                        data: {hasAssets: 0, detector: 0}
                    });
                }
            });
        });
    };

    mapState(state) {
        return {
            equipment: state.equipmentCalibration.equipment,
            detector: state.equipmentCalibration.detector,
            detectorsNumber: state.equipmentCalibration.equipmentDetectorProbeGrid.itemsCount
        }
    }

    $onDestroy() {
        this.unsubscribe();
        if (this.removeDialog)
            this.$mdDialog.hide(this.removeDialog);
    }
}

EquipmentCalibrationDetectorProbeController.$inject = ['$ngRedux', '$state', '$mdDialog', 'NavigationService', 'EquipmentCalibrationActions', 'Notifier'];

export const equipmentCalibrationDetectorProbe = {
    controller: EquipmentCalibrationDetectorProbeController,
    template: require('./equipment-calibration-detector-probe.html')
};
